import { Select, MenuItem, FormControl, InputLabel, Box } from "@mui/material";
import { useData } from "../hooks/useData";
import { getColorsByProductCode } from "../constants/colors";

export default function ColorSelect({ lineId }) {
  const { lines, updateLine, selectedProduct } = useData();
  const line = lines.find((l) => l.id === lineId);
  if (!line) return null;

  const colors = getColorsByProductCode(selectedProduct?.code);

  // ← ADD THIS: If current color doesn't exist → use first available
  const validColor = line.color;

  const handleChange = (e) => {
    const colorCode = e.target.value;
    const colorObj = colors.find((c) => c.code === colorCode);
    updateLine(lineId, {
      color: colorCode,
      colorName: colorObj?.name || "Unknown",
    });
  };

  return (
    <FormControl
      size="small"
      sx={{
        flex: { xs: "1 1 auto", sm: "1 1 200px" },
        minWidth: { xs: "100%", sm: 160 },
      }}
    >
      <InputLabel>Color</InputLabel>
      <Select value={validColor} onChange={handleChange} label="Color">
        {colors.map((color) => (
          <MenuItem key={color.code} value={color.code}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  bgcolor: color.hex || color.code, // ← HEX OR CODE
                  border: "1px solid #ccc",
                  borderRadius: "50%",
                }}
              />
              {color.name}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
